//Note: functions that access 'this' cannot be written as arrow functions
import Consts from "./Consts";
export default {
  image: {
    getUrl: (item, size) => {
      let dimensions = size === "max" ? "max" : size + "x" + size;
      return `${Consts.api.baseUrlImage}${item["artifact.defaultMediaIdentifier"]}?dimension=${dimensions}`;
    },
    getUrlDownload: (item, size) => {
      let dimensions = size === "max" ? "max" : size + "x" + size;
      return `${Consts.api.baseUrlImage}${item["artifact.defaultMediaIdentifier"]}?dimension=${dimensions}&filename=${item["identifier.id"]}.jpg`;
    },
  },
  lists: {
    removeDuplicates: (array, prop) => {
      return array.filter((obj, pos, arr) => {
        return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    shuffleArray: (array) => {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    },
    removeTechnicFromTitle: function (array) {
      for (let i = 0; i < array.length; i++) {
        this.removeTechnicFromTitleInItem(array[i]);
      }
    },
    removeTechnicFromTitleInItem: (item) => {
      let title = item["artifact.ingress.title"];
      let index = title.indexOf(" [");
      if (index > -1) {
        title = title.slice(0, index).trim();
        item["artifact.ingress.title"] = title;
      }
    },
    minAndMaxYearFromList: (array) => {
      let min = parseInt(new Date().getFullYear());
      let max = 0;
      for (let i = 0; i < array.length; i++) {
        const item = array[i];
        const year = item["artifact.ingress.production.toYear"];
        if (year < min) min = year;
        if (year > max) max = year;
      }
      return { min: min, max: max };
    },

    getCategoryFolderIds: (array) => {
      let categoryFolders = [];
      for (let i = 0; i < array.length; i++) {
        let item = array[i];
        if (
          item["artifact.type"] === "Folder" &&
          item["artifact.pictureCount"] > 0
        ) {
          categoryFolders.push(item["artifact.uuid"]);
        }
      }
      return "(" + categoryFolders.join(" OR ") + ")";
    },
    fixSearchResults: function (array, from, to) {
      let filtered = [];
      for (let i = 0; i < array.length; i++) {
        let item = array[i];

        if (item["artifact.type"] === "Folder") continue;
        if (item["artifact.hasChildren"]) continue;
        if (!item["artifact.defaultMediaIdentifier"]) continue;

        this.removeTechnicFromTitleInItem(item);

        let year = item["artifact.ingress.production.toYear"];
        if (!!year && (year < from || to < year)) continue;
        filtered.push(item);
      }
      return filtered;
    },
    fixCategoryResults: function (array) {
      let filtered = [];
      for (let i = 0; i < array.length; i++) {
        let item = array[i];

        if (item["artifact.hasChildren"]) continue;
        if (!item["artifact.defaultMediaIdentifier"]) continue;

        this.removeTechnicFromTitleInItem(item);
        filtered.push(item);
      }
      return filtered;
    },
  },
  objects: {
    isEmptyObject(obj) {
      return Object.keys(obj).length === 0;
    },
  },
  dom: {
    breadcrumb: {
      addLinkToSelf: () => {
        const currentLi = document.querySelector("nav.breadcrumb li.current");
        if (!currentLi) return;
        const text = currentLi.innerHTML;
        currentLi.innerHTML =
          "<a href='" + window.location.pathname + "'>" + text + "</a>";
      },
      addCategory: function (category) {
        this.removeCurrentCategory();
        const currentLi = document.querySelector("nav.breadcrumb li.current");
        if (!currentLi) return;
        const ul = currentLi.parentElement;
        const catLi = document.createElement("li");
        catLi.id = "current-category";
        catLi.className = "current";
        catLi.innerHTML = category.category;
        ul.appendChild(catLi);
      },
      removeCurrentCategory: () => {
        const elem = document.getElementById("current-category");
        if (!elem) return;
        elem.remove();
      },
    },
    setTitle: (props) => {
      try {
        const title = props?.cmsData?.title ?? '';
        let producer = props?.item?.['artifact.ingress.producer']??'';
        if (producer.indexOf(', ')){
          const split = producer.split(', ');
          producer = split[1] + ' ' + split[0];
        }
        let artTitle =props?.item?.['artifact.ingress.title'] ?? '';
        if (artTitle.indexOf('[')){
          artTitle = artTitle.split('[')[0];
        }
        document.title = `${title} - ${producer}: ${artTitle}`;
      } catch(error) {
        console.error(error);
      }
    }
  },
  url: {
    getParameterId: () => {
      var url = new URL(location.href);
      var id = url.searchParams.get(Consts.objectIdQueryParameter);
      return id;
    },
    getUrlForItem: (item) => {
      var id = item["identifier.id"];
      var url = new URL(location.href);
      url.searchParams.set(Consts.objectIdQueryParameter, id);

      return "" + url;
    },
    getParameterIndex: function (items, slide, prioritizedImage) {
      const paramId = this.getParameterId();
      const id = paramId || prioritizedImage;
      if (!id) {
        this.setParameterId(items[slide]);
        return slide;
      }
      var index = -1;
      var item = items.find((elem, i) => {
        index = i;
        return elem["identifier.id"] === id;
      });
      if (!item) {
        this.setParameterId(items[slide]);
        return slide;
      }
      this.setParameterId(item);
      return !item ? slide : index;
    },
    setParameterId: function (item) {
      if (!item) return;
      const id = item["identifier.id"];
      var url = new URL(location.href);
      url.searchParams.set(Consts.objectIdQueryParameter, id);
      this.addParameterToShareButtons(id);
      const currentState = history.state;
      history.replaceState(currentState, null, url);
    },
    addParameterToShareButtons: (id) => {
      const urlEncodedEqualSign = "%3d";
      const urlEncodedQuestionMark = "%3f";
      const parameter = `${urlEncodedQuestionMark}${Consts.objectIdQueryParameter}${urlEncodedEqualSign}${id}`;
      const links = document.querySelectorAll("[data-some-share-link]");
      if (links && links.length > 0) {
        var arr = [];
        for (var i = links.length; i--; arr.unshift(links[i])); //ie fix
        arr.forEach((item) => {
          let url = item.getAttribute("href");
          const paramStart = `${urlEncodedQuestionMark}${Consts.objectIdQueryParameter}`;
          const paramIndex = url.indexOf(paramStart);
          url =
            paramIndex === -1
              ? `${url}${parameter}`
              : `${url.slice(0, paramIndex)}${parameter}`;
          item.setAttribute("href", url);
        });
      }
      const errorLinks = document.querySelectorAll("[data-report-error-link]");
      if (errorLinks && errorLinks.length > 0) {
        var errarr = [];
        for (var j = errorLinks.length; j--; errarr.unshift(errorLinks[j])); //ie fix
        errarr.forEach((item) => {
          let url = new URL(location.origin + item.getAttribute("href"));
          url.searchParams.set(Consts.objectIdQueryParameter, id);
          item.setAttribute("href", url.href.replace(location.origin, ""));
        });
      }
    },
  },
};
